<mat-toolbar class="loginFooter">
    <span>
      Desenvolvido com <i class="material-icons"> favorite </i> por
      <strong>Lucas Vitiello</strong>
    </span>
  </mat-toolbar>